export interface ForceChangePasswordError {
  message: string;
  type: string;
}

export interface ActivationPageProps {
  passwordField: React.ReactNode;
  submitButton: React.ReactNode;
  errorMessage: React.ReactNode | null;
}

export const CarrierVoluntellLandingPageVariant = {
  V1: "carrier_landing_1",
  V2: "carrier_landing_2",
} as const;
export type CarrierVoluntellLandingPageVariant =
  (typeof CarrierVoluntellLandingPageVariant)[keyof typeof CarrierVoluntellLandingPageVariant];

export const ShipperVoluntellLandingPageVariant = {
  V1: "shipper_landing_1",
} as const;
export type ShipperVoluntellLandingPageVariant =
  (typeof ShipperVoluntellLandingPageVariant)[keyof typeof ShipperVoluntellLandingPageVariant];
